import { connect } from 'react-redux';
import isTeamAdmin from 'store/selectors/isTeamAdmin';

const mapStateToProps = state => ({
  isTeamAdmin: isTeamAdmin(state),
});

export default connect(mapStateToProps);
